module.exports = __webpack_public_path__ + "static/media/Lato-Italic.e0867c8f.ttf";